// extracted by mini-css-extract-plugin
export var header = "_bj-0";